// USAGE
//Optional reset for testing
//  In your browser console, run:
// localStorage.removeItem('tiwsVisitModalShown_dev');
// localStorage.removeItem('tiwsVisitModalShown_live');

(function () {
  var environment = window.TIWS && window.TIWS.environment
    ? window.TIWS.environment
    : 'live';

  var visitModalShownKey = 'tiwsVisitModalShown_' + environment;
  var visitModalExpiryDays = 7;
  // var visitModalExpiryDays = 14;
  // var visitModalExpiryDays = 30;
  var cartAddModalPendingKey = 'tiwsCartAddModalPending_' + environment;


  var modal;

  function isCartAddUrl(url) {
    if (!url) {
      return false;
    }

    return String(url).indexOf('/cart/add') !== -1;
  }

  function setModalContent(type) {
    var title = modal.querySelector('[data-tiws-modal-title]');
    var body = modal.querySelector('[data-tiws-modal-body]');

    if (!title || !body) {
      return;
    }

    if (type === 'cart') {
      title.textContent = 'Item Added to Cart';
      body.textContent = 'Your item has been added to the shopping cart.';
    } else {
      title.textContent = 'Important Notice';
      body.textContent = 'Your session-based message goes here.';
    }
  }

  function openModal(type) {
    if (!modal) {
      return;
    }

    setModalContent(type);

    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tiws-visit-modal-open');
  }

  function closeModal() {
    if (!modal) {
      return;
    }

    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tiws-visit-modal-open');
  }

  function hasVisitModalBeenShownRecently() {
    var storedValue = localStorage.getItem(visitModalShownKey);

    if (!storedValue) {
      return false;
    }

    var storedTime = parseInt(storedValue, 10);

    if (isNaN(storedTime)) {
      return false;
    }

    var now = Date.now();
    var expiryTime = visitModalExpiryDays * 24 * 60 * 60 * 1000;

    return now - storedTime < expiryTime;
  }

  function showVisitModalOncePerExpiryPeriod() {
    if (!hasVisitModalBeenShownRecently()) {
      openModal('visit');
      localStorage.setItem(visitModalShownKey, String(Date.now()));
    }
  }

  function showCartAddModal() {
    openModal('cart');
  }

  function watchFetchCartAdds() {
    if (!window.fetch) {
      return;
    }

    var originalFetch = window.fetch;

    window.fetch = function () {
      var input = arguments[0];
      var init = arguments[1] || {};
      var url = typeof input === 'string' ? input : input && input.url;
      var method = init.method || input && input.method || 'GET';

      return originalFetch.apply(this, arguments).then(function (response) {
        if (
          response &&
          response.ok &&
          String(method).toUpperCase() === 'POST' &&
          isCartAddUrl(url)
        ) {
          window.dispatchEvent(new CustomEvent('tiws:cart:add'));
        }

        return response;
      });
    };
  }

  function watchXhrCartAdds() {
    if (!window.XMLHttpRequest) {
      return;
    }

    var originalXhrOpen = XMLHttpRequest.prototype.open;
    var originalXhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._tiwsCartAddMethod = method;
      this._tiwsCartAddUrl = url;

      return originalXhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;

      xhr.addEventListener('load', function () {
        if (
          xhr.status >= 200 &&
          xhr.status < 300 &&
          String(xhr._tiwsCartAddMethod).toUpperCase() === 'POST' &&
          isCartAddUrl(xhr._tiwsCartAddUrl)
        ) {
          window.dispatchEvent(new CustomEvent('tiws:cart:add'));
        }
      });

      return originalXhrSend.apply(this, arguments);
    };
  }

  function watchNormalCartForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!form || !form.action) {
        return;
      }

      if (isCartAddUrl(form.action)) {
        sessionStorage.setItem(cartAddModalPendingKey, 'yes');
      }
    }, true);
  }

  watchFetchCartAdds();
  watchXhrCartAdds();
  watchNormalCartForms();

  document.addEventListener('DOMContentLoaded', function () {
    modal = document.getElementById('tiws-visit-modal');

    if (!modal) {
      return;
    }

    modal.querySelectorAll('[data-tiws-visit-modal-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    });

    window.addEventListener('tiws:cart:add', showCartAddModal);

    if (sessionStorage.getItem(cartAddModalPendingKey) === 'yes') {
      sessionStorage.removeItem(cartAddModalPendingKey);
      showCartAddModal();
      return;
    }

    showVisitModalOncePerExpiryPeriod();
  });
})();
